<template>
<div>
    <div class="form" v-if="$route.path == '/wapProducts' || $route.path == '/wapSMSPro' || $route.path == '/wapVDPro'">
        <div class="titleBox">申请试用</div>
        <div class="form_box">
            <div class="form_ok" v-if="istrial">
                <img src="@/assets/images/form_icon.png" alt="">
                <p>已经提交申请，运营人员将在3-5个工作日内联系您。</p>
            </div>
            <div class="form_ct" v-else>
                <p>您好，请您填写试用申请，我们的客服将尽快联系您~</p>
                <label>
                    <span><i style="color:red;">*</i>手机:</span>
                    <input v-model.trim="phon" type="text">
                </label>
                <label>
                    <span><i style="color:red;">*</i>邮箱:</span>
                    <input v-model.trim="eilm" type="text">
                </label>
                <label>
                    <span><i style="color:red;">*</i>公司:</span>
                    <input v-model.trim="name" type="text">
                </label>
                <label>
                    <span>需求:</span>
                    <textarea></textarea>
                </label>
                <spna class="app_btn" @click="chtrial">申请试用</spna>
            </div>
        </div>
    </div>
    <div class="navwrap">
        <van-cell is-link title="主页" @click="issot"  to="/wapHome" />
        <van-cell  @click="childshow = !childshow" >
            <template #title>
                <span :class="{selcol:childshow}">产品服务</span>
            </template>
            <template #right-icon>
                <van-icon name="arrow" v-if="!childshow"/>
                <span v-else class="selcol">• • •</span>
            </template>
        </van-cell>

        <div style="padding-left:20px;" v-show="childshow">
            <van-cell is-link title="5G消息" @click="issot" to="/wapProducts" />
            <van-cell is-link title="短信" @click="issot" to="/wapSMSPro" />
            <van-cell is-link title="短信视频" @click="issot" to="/wapVDPro" />
        </div>

        <van-cell is-link title="行业应用" @click="issot"  to="/wapApplication" />
        <van-cell is-link title="成为开发者" @click="issot"  to="/wapDeveloper"/>
        <van-cell is-link title="联系我们" @click="isde" />
        <!-- <van-action-sheet v-model="show" :actions="actions" @select="onSelect" /> -->
    </div>
    <div class="footBtn">
        <img src="@/assets/images/wap/footLogo.png" alt="">
        <p>版权所有 © 彩讯科技股份有限公司.All right reserved</p>
        <p>粤ICP备15050890号-2</p>
    </div>
</div>
</template>

<script>
export default {
    data(){
        return{
            childshow:false,
            istrial:false,
            phon:'',
            eilm:'',
            name:'',
        }
    },
    methods:{
        isde(){
            this.$router.push('/wapDeveloper')
            this.$nextTick(()=>{
                setTimeout(()=>{
                    const a = document.createElement('a')
                    a.setAttribute('href','#relation')
                    a.click()
                },300)
            })
        },
        issot(){
            document.documentElement.scrollTop = 0
        },
        chtrial(){
            this.istrial = true
        }
    },
}
</script>

<style scoped>
.navwrap /deep/ .van-cell::after{
    display: none;
}
.navwrap /deep/ .van-cell__right-icon{
    color: #fff;
}
.navwrap /deep/ .van-cell{
    background: none;
    color: #fff;
}
.navwrap /deep/ .van-cell--clickable:active{
    color: #1C2A39;
}
 .navwrap{
    /* position: relative;
    z-index: 999; */
    background: #2A2B2C;
    padding-top:10px;
    border-bottom: 1px solid #5C5D5E;
}
/* 底部黑色背景列表内容Start */
.footBtn{
    padding: 10px 20px;
    box-sizing: border-box;
    background: #2A2B2C;
}
.footBtn img{
    width: 4.36rem;
    height: 1.12rem;
}
.footBtn p{
    color: #F4F5F6;
    line-height: 25px;
    font-size: 12px;
    margin-top: 10px;
}
.selcol{
    color: #8E9090;
}
.titleBox{
    width: 100%;
    height: 58px;
    line-height: 58px;
    color: #1C2A39;
    font-size: 20px;
    background: url('../assets/images/wap/title.png') no-repeat left top;
    background-size:29px;
    padding-left: 15px;
    /* border-bottom: 1px solid #EDEEF0; */
}
.form{
    margin-top:10px;
    background-color: #fff;
}
.form_box .form_ct{
    padding:0.4rem 0.32rem 0.8rem;
}
.form_box .form_ct p{
    font-size: 0.36rem;
    color: #000;
    text-align: center;
    margin-bottom: 0.53rem;
}
.form_box .form_ct label{
    display: block;
    width: 100%;
    margin: 0 auto;
    text-align: center;
}
.form_box .form_ct label span{
    display: inline-block;
    width: 12%;
    font-size: 0.32rem;
}
.form_box .form_ct label input,
.form_box .form_ct label textarea{
    width: 80%;
    height: 0.96rem;
    background: #F7F8F9;
    border-radius: 0.08rem;
    border: 2px solid #DDDDDD;
    margin-bottom:0.26rem;
    font-size: 0.26rem;
}
.form_box .form_ct label textarea{
    height: 1.71rem;
    vertical-align: top;
    resize: none;
}
.form_box .form_ct .app_btn{
    display: inline-block;
    width: 100%;
    cursor: pointer;
    background-color: #1791FF;
    color: #fff;
    text-align: center;
    font-size: 0.37rem;
    padding: 0.34rem 0;
    border-radius: 5px;
}
.form_box .form_ok{
    text-align: center;
    padding:0.4rem 0.32rem 0.8rem;
}
.form_box .form_ok img{
    width: 2rem;
}
.form_box .form_ok p{
    font-size: 0.42rem;
}
</style>


// WEBPACK FOOTER //
// src/components/wefot.vue